const menuData = [
    {
      id: 1,
      title: "Home",
      newTab: false,
      path: "/",
    },
    {
      id: 2,
      title: "About",
      newTab: false,
      path: "#about",
    },
    {
      id: 3,
      title: "Services",
      newTab: false,
      path: "/services",
      submenu: [
        { id: 301, title: "SAP", path: "/servicepages/sap", url: "sap" },
        { id: 302, title: "Power BI", newTab: false, path: "/servicepages/powerbi", url: "power-bi" },
        { id: 303, title: "Web Design", newTab: false, path: "/servicepages/webdesign", url: "web-design" },
        { id: 304, title: "CAD design", newTab: false, path: "/servicepages/caddesign", url: "cad-design" },
        { id: 305, title: "Solid Works", newTab: false, path: "/servicepages/solidworks", url: "solid-works" },
        { id: 306, title: "CATIA", newTab: false, path: "/servicepages/catia", url: "catia" },
        { id: 307, title: "RhinocerOS3D", newTab: false, path: "/servicepages/rhinocer", url: "rhinoceros3d" },
        { id: 308, title: "Autodesk Revit", newTab: false, path: "/servicepages/autodesk", url: "autodesk-revit" },
        // { id: 309, title: "Etbs", newTab: false, path: "/servicepages/etbs", url: "etbs" },
        // { id: 310, title: "STAAD Pro", newTab: false, path: "/servicepages/staad", url: "staad-pro" },
        { id: 311, title: "Final CutPro", newTab: false, path: "/servicepages/finalcutpro", url: "final-cutpro" },
        { id: 312, title: "Cinema 4D", newTab: false, path: "/servicepages/cinema", url: "cinema-4d" },
        { id: 313, title: "Autodesk maya", newTab: false, path: "/servicepages/autodeskmaya", url: "autodesk-maya" },
        { id: 314, title: "Animaker", newTab: false, path: "/servicepages/animaker", url: "animaker" },
        { id: 315, title: "GIMP", newTab: false, path: "/servicepages/gimp", url: "gimp" },
      ]
    },
    {
      id: 4,
      title: "Contact",
      newTab: false,
      path: "#contact",
    },
    {
      id: 5,
      title: "Events",
      newTab: false,
      path: "/events",
    },
  ];
  
  export default menuData;
  